// basically what we were doing with lodash's escapeRegExp method
// except for all the complicated logic for arrays and objects
// since we only use it for strings
export function escapeRegex(text: string): string {
    const reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    const reHasRegExpChar = RegExp(reRegExpChar.source);
    return (text && reHasRegExpChar.test(text)) ? text.replace(reRegExpChar, '\\$&') : text;
}
